import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import FooterEn from "../footer-en";
import HeaderEn from "../header-en";

function CheckoutSuccessEn(props) {
  const [sendMessage, setSendMessage] = useState(
    "Hello,I'mInCheckoutSuccessPageEn"
  );

  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
    return true;
  };

  return (
    <div className="container-v1">
      <HeaderEn />
      <div className="product d-ltr justify-content-center align-items-center">
        <h2>{"Thanks for your payment :)"}</h2>
      </div>
      <FooterEn />
    </div>
  );
}

export default CheckoutSuccessEn;
